import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/tmp/167c8514/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`If you’ve designed a pattern that is not currently in Carbon, contributing it back allows others in the community to refine and use your pattern in their projects.`}</p>
    </PageDescription>
    <h2 {...{
      "id": "first-steps-to-contributing"
    }}>{`First steps to contributing`}</h2>
    <p>{`The process for contributing a pattern will depend on the pattern’s complexity, but all contributions start by `}<a parentName="p" {...{
        "href": "https://github.com/carbon-design-system/carbon-website/issues/new"
      }}>{`opening a Github issue`}</a>{`. Include a detailed description in which you:`}</p>
    <ul>
      <li parentName="ul">{`Define your pattern and explain the rationale`}</li>
      <li parentName="ul">{`Clarify whether it uses existing components, new components, or both`}</li>
      <li parentName="ul">{`Include mockups and/or prototypes of any fidelity`}</li>
      <li parentName="ul">{`Include competitive and comparative analysis, and any inspirations from other products`}</li>
    </ul>
    <p>{`This issue will be the staging ground for the pattern contribution, and you should expect the Carbon core team and the community to weigh in with suggestions at each step.`}</p>
    <p>{`We encourage you to surface work in progress. If you’re not able to complete all of the parts yourself, someone in the community may be able to pick up where you leave off.`}</p>
    <h2 {...{
      "id": "parts-of-a-pattern-contribution"
    }}>{`Parts of a pattern contribution`}</h2>
    <p>{`Here are all of the steps for a complete contribution.`}</p>
    <h4 {...{
      "id": "1-provide-a-rationale"
    }}>{`1. Provide a rationale`}</h4>
    <p>{`Explain how your pattern will address user needs and solve a problem. Carbon serves the widest possible range of products, and contributions that increase the scope of the system are more likely to be accepted. Be sure to include any research and feedback.`}</p>
    <h4 {...{
      "id": "2-explain-behaviors-content-structure-and-functionality"
    }}>{`2. Explain behaviors, content structure, and functionality`}</h4>
    <ul>
      <li parentName="ul">{`Describe pattern behaviors with descriptions, user flows, and/or prototypes.`}</li>
      <li parentName="ul">{`Use wireframes or sketches to explain the visual hierarchy of components.`}</li>
      <li parentName="ul">{`Show the content structure and content elements required, such as title, body, image, labels, video.`}</li>
      <li parentName="ul">{`Include details of how the pattern user experience meets standards for accessibility.`}</li>
      <li parentName="ul">{`Show the pattern in context.`}</li>
    </ul>
    <h4 {...{
      "id": "3-create-pattern-visuals"
    }}>{`3. Create pattern visuals`}</h4>
    <ul>
      <li parentName="ul">{`Create high fidelity designs and prototypes that follow our `}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon-website/wiki/Production-guidelines"
        }}>{`production guidelines`}</a>{`.`}</li>
      <li parentName="ul">{`Evaluate your pattern to ensure it meets `}<a parentName="li" {...{
          "href": "/guidelines/accessibility/overview"
        }}>{`accessibility standards and guidelines`}</a>{`, and provide details of compliance.`}</li>
    </ul>
    <h4 {...{
      "id": "4-create-design-specs"
    }}>{`4. Create design specs`}</h4>
    <ul>
      <li parentName="ul">{`If you are creating new components for use in the pattern, you’ll need to create sizing and styling annotations for these new components. The design specs should provide a developer with everything they need to create the design in code. Check out our `}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon-website/wiki/Production-guidelines#spec-guidelines"
        }}>{`production guidelines`}</a>{` to get started.`}</li>
      <li parentName="ul">{`If you are using a combination of new and existing components, you should note clearly where each is used.`}</li>
    </ul>
    <h4 {...{
      "id": "5-create-sketch-symbols"
    }}>{`5. Create Sketch symbols`}</h4>
    <ul>
      <li parentName="ul">{`Any new patterns or changes to existing patterns will also live in a Sketch kit and so you will need to create Sketch symbols for components used.`}</li>
      <li parentName="ul">{`Check out `}<a parentName="li" {...{
          "href": "https://www.sketch.com/docs/symbols/creating-symbols/"
        }}>{`Sketch’s guide`}</a>{` for creating a symbol.`}</li>
    </ul>
    <h4 {...{
      "id": "6-document-the-pattern"
    }}>{`6. Document the pattern`}</h4>
    <ul>
      <li parentName="ul">{`Use the pattern `}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon-website/blob/master/docs/pattern-template.mdx"
        }}>{`Markdown template`}</a>{` to document pattern guidelines and usage.`}</li>
      <li parentName="ul">{`The site `}<a parentName="li" {...{
          "href": "./documentation"
        }}>{`documentation`}</a>{` should include your contextual images and step-by-step instructions that allow designers to effectively implement your pattern. Be sure to include the context and the rationale for any choices.`}</li>
    </ul>
    <h4 {...{
      "id": "7-prepare-for-experimental-release"
    }}>{`7. Prepare for experimental release`}</h4>
    <p>{`If accepted, the pattern will be released as `}<a parentName="p" {...{
        "href": "/experimental/about/overview"
      }}>{`Experimental`}</a>{` until community tested and approved for general production.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      